'use client';

import { createContext, type ReactNode, useContext, useState } from 'react';

const HeaderContext = createContext<{
  onValueChange: (key: string) => void;
  value: string;
}>({
  value: '',
  onValueChange: () => {},
});

export const useHeaderContext = () => {
  const context = useContext(HeaderContext);
  if (!context) {
    throw new Error('useHeaderContext must be used within a HeaderProvider');
  }
  return context;
};

export const HeaderProvider = ({ children }: { children: ReactNode }) => {
  const [value, setValue] = useState<string>('');

  const onValueChange = (key: string) => {
    setValue(key);
  };

  return (
    <HeaderContext.Provider value={{ onValueChange, value }}>
      {children}
    </HeaderContext.Provider>
  );
};
